import { ImageProxyGravity } from './ImageProxyGravity';
import { ImageProxyOptions } from './ImageProxyOptions';
import { ImageProxyResize } from './ImageProxyResize';
import { getS3URL } from './getS3URL';

export function getImageProxyURL(sourceURL: string, options: ImageProxyOptions): string {
  const sourceS3URL = getS3URL(sourceURL);

  const result = `${[
    options.imageProxyURL,
    'unsafe',
    options.resize
      ? `rs:${options.resize.type || ImageProxyResize.Fit}:${options.resize.width ?? 0}:${
          options.resize.height ?? 0
        }`
      : false,
    options.gravity
      ? `g:${options.gravity.type || ImageProxyGravity.CE}:${options.gravity.offsetX || 0}:${
          options.gravity.offsetY || 0
        }`
      : false,
    options.quality ? `q:${options.quality}` : 'q:75',
    options.plain ? 'plain' : false,
    options.plain
      ? [sourceS3URL, options.format].filter(Boolean).join('@')
      : [btoa(sourceS3URL), options.format].filter(Boolean).join('.'),
  ]
    .filter(Boolean)
    .join('/')}`;

  if (!result.startsWith('http')) {
    return `https://${result}`;
  }

  return result;
}
